import React, { useEffect, useRef } from "react";
import { Button } from "@/components/ui/button";
import { MessageCircle } from "lucide-react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { LINKS } from "@/mock";

gsap.registerPlugin(ScrollTrigger);

export default function FloatingWhatsApp() {
  const buttonRef = useRef(null);

  useEffect(() => {
    const button = buttonRef.current;
    if (!button) return;

    const ctx = gsap.context(() => {
      // Verstecke den Button initial
      gsap.set(button, { 
        autoAlpha: 0, 
        scale: 0.8,
        y: 20
      });

      // Zeige den Button wenn User aus Hero-Sektion scrollt
      ScrollTrigger.create({
        trigger: "#start", // Hero section ID
        start: "bottom top",
        end: "bottom top",
        onEnter: () => {
          gsap.to(button, {
            autoAlpha: 1,
            scale: 1,
            y: 0,
            duration: 0.4,
            ease: "back.out(1.7)"
          });
        },
        onLeaveBack: () => {
          gsap.to(button, {
            autoAlpha: 0,
            scale: 0.8,
            y: 20,
            duration: 0.3,
            ease: "power2.in"
          });
        }
      });

      // Pulsierender Effekt für Aufmerksamkeit
      gsap.to(button, {
        scale: 1.05,
        duration: 2,
        ease: "power2.inOut",
        yoyo: true,
        repeat: -1,
        delay: 1
      });
    });

    return () => ctx.revert();
  }, []);

  return (
    <div 
      ref={buttonRef}
      className="fixed bottom-6 right-6 z-40"
      style={{ visibility: 'hidden' }} // Initial versteckt
    >
      <Button 
        asChild 
        className="h-14 w-14 rounded-full shadow-xl bg-[var(--brand-red)] hover:bg-red-600 text-white border-2 border-white/20 hover:border-white/40 transition-all duration-200 hover:scale-110 active:scale-95"
      >
        <a 
          href={LINKS.whatsappLink} 
          target="_blank" 
          rel="noreferrer"
          title="Jetzt WhatsApp starten"
          aria-label="WhatsApp-Chat starten"
        >
          <MessageCircle className="h-6 w-6" />
        </a>
      </Button>
    </div>
  );
}
